import { useTryCallApi } from 'common/hooks/use-try-call-api'
import { AiAgentSettingsService, PresenterAIAgentSettingResponse } from 'common/open-api'
import { FeatureFlagNames } from 'common/open-features'
import { useCheckFlag } from 'common/open-features/hooks'
import { useEffect } from 'react'

/**
 * Fetches the current office's AI agent setting status via `AiAgentSettings.getSettingsAiAgent`
 * (GET /settings/ai-agent) and exposes the toggle/consent flags.
 */
export const useAIAgentSettingStatus = () => {
  const { isEnable: enableAssetCategoryJudgmentAI } = useCheckFlag(FeatureFlagNames.AssetCategoryJudgmentAI)
  const { data, callApi } = useTryCallApi(AiAgentSettingsService.getSettingsAiAgent)

  useEffect(() => {
    if (enableAssetCategoryJudgmentAI) {
      callApi()
    }
  }, [enableAssetCategoryJudgmentAI, callApi])

  return {
    aiAgentSettingEnabled: (data?.data as PresenterAIAgentSettingResponse)?.enabled ?? false,
  }
}
